import { IWordBank, WordBankCategory } from 'types'

export const SET_WORD_BANKS = 'top5.setWordBanks'
export const SET_IS_LOADING = 'top5.setIsLoading'
export const SET_IS_SUBMITTING = 'top5.setIsSubmitting'
export const SET_ERROR = 'top5.setError'
export const RESET_OWN_WORD_BANK = 'top5.resetOwnWordBank'
export const SET_IS_LOADING_CATEGORIES = 'top5.setIsLoadingCategories'

export function setWordBanks(resource: WordBankCategory, wordBanks: IWordBank[]) {
  return {
    type: SET_WORD_BANKS,
    payload: { [resource]: wordBanks }
  } as const
}

export function setIsLoading(resource: WordBankCategory, isLoading: boolean) {
  return {
    type: SET_IS_LOADING,
    payload: { [resource]: isLoading }
  } as const
}

export function setIsSubmitting(resource: WordBankCategory, isSubmitting: boolean) {
  return {
    type: SET_IS_SUBMITTING,
    payload: { [resource]: isSubmitting }
  } as const
}

export function setIsLoadingCategories(payload: boolean) {
  return {
    type: SET_IS_LOADING_CATEGORIES,
    payload
  } as const
}

export type Top5Action = ReturnType<
  typeof setWordBanks | typeof setIsLoading | typeof setIsSubmitting | typeof setIsLoadingCategories
>
